<template>
  <div class="clm-slider">
    <div class="clm-slider__block">
      <div class="clm-slider__img">
        <picture>
          <source media="(min-width: 1024px)"
                  srcset="/local/img/main-page/slider/01.jpg"/>
          <source srcset="/local/img/main-page/slider/mobile-01.svg" />
          <img src="/local/img/main-page/slider/01.jpg" alt="main-photo" />
        </picture>
      </div>
    </div>
    <div class="clm-slider-text">
      <div class="clm-slider-text__container clm-container">
        <div class="clm-slider-text__block">
          <div class="clm-slider-text__title" v-html="pageTitle"></div>
          <div class="clm-slider-text__subtitle" v-html="pageSubtitleOne"></div>
        </div>
        <div class="clm-slider-btns">
          <a-btn :is-color="true" @action="$emit('popup:activate', 'authFormAuth')">{{$t('the-auth-slider.loginAccount')}}</a-btn>
          <a-btn @action="$emit('popup:activate', 'authFormCreate')">{{$t('the-auth-slider.createAccount')}}</a-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aBtn from "./a-btn.vue";
import authForm from "../../auth-form/auth-form.vue";
export default {
  name: "the-auth-slider",
  components: {
    aBtn,
    authForm
  },
  props: {
    pageTitle: String,
    pageSubtitleOne: String,
    mainSliderSlides: {
      type: Array,
      default: ['/local/img/main-page/slider/01.jpg']
    },
    pageParams: Object
  }
}
</script>
